/**
 * @param {String} string
 *
 * @returns {String}
 */
export default function getTextFromHtmlString(string) {
  return (string || '')
    .replace(/<\/?[^>]+(>|$)/g, '')   
    .replace(/["()[\]]/g, '');        
}